import type { FC } from 'react';
import { useAreas } from '@/hooks';
import TabsCascader, { type TabsCascaderProps } from '../TabsCascader';
import './index.less';

export type IProps = Omit<TabsCascaderProps, 'options'>;

const AddressCascaderFormItem: FC<IProps> = (props) => {
  const { areas } = useAreas();

  return (
    <TabsCascader
      className="address-cascader-form-item"
      placeholder="请选择地区"
      {...props}
      options={areas as any}
    />
  );
};

export default AddressCascaderFormItem;
